import React from 'react';
import { useHistory } from 'react-router';
import MyButton from '../form/MyButton';
import useWindowSize from '../../hooks/useWindowSize';

const ReturnTopBar = (props) => {
  const history = useHistory();
  const [width] = useWindowSize();

  const goTo = () => {
    history.push(props.url);
  };

  return (
    <div className="boutons-topbar-contenu">
      <MyButton className={"classic-button btn-default color-fond-bleu"} type="button" labelImportant={props.label ? props.label : 'Annuler'} href="#" onClick={() => goTo()} />
    </div>
  );

};

export default ReturnTopBar;
